import React from 'react';
import { Field } from 'react-final-form';
import { Box } from '@mui/material';
import Bluebird from 'bluebird';
import PictureUpload from './PictureUpload';
import snackbarHelper from '../helpers/snackbarHelper';

// Food donor / receiving agency logo. The picture is uploaded to S3 as soon as the crop is confirmed. With `onSave` the
// logo is saved right away, like the rescuer profile picture (the field then follows the saved logo, so it never makes
// the form dirty), otherwise only its URL is kept in the form field and saved together with the rest of the form.
const LogoUploadField = ({ name = 'logo_url', alt, onSave }) => {
  const handleSave = (logoUrl) =>
    Bluebird.try(() => onSave(logoUrl))
      .then(() => {
        if (logoUrl) {
          snackbarHelper.success('Logo updated!');
        }
      })
      .catch((e) => {
        snackbarHelper.error(e.message);
      });

  return (
    <Field
      name={name}
      render={({ input }) => (
        <Box mb={2}>
          <PictureUpload
            value={input.value}
            onChange={onSave ? handleSave : input.onChange}
            alt={alt}
            fileName="logo.jpg"
            label="logo"
          >
            {alt ? alt.charAt(0).toUpperCase() : null}
          </PictureUpload>
        </Box>
      )}
    />
  );
};

export default LogoUploadField;
